import { motion } from "framer-motion"
import styled from "@emotion/styled"

import { fullGrid } from "css/grid"
import getMediaQuery from "css/breakpoints"
import { columnWidth } from "css/columnWidth"
import { buttonIcon, translucentDark } from "css/buttons"

import { modularTexts } from "components/articles/common"

export const Root = styled.section`
  ${fullGrid}
  grid-template-rows: ${props =>
    props.order === "text-video" ? "[top-row content] auto [vid] auto [bottom-row]" : "[top-row vid] auto [content] auto [bottom-row]"};
`

export const VideoContent = styled.figure`
  ${columnWidth}
  grid-row: vid;
  position: relative;
  --transition: 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.1s;
  clip-path: ${({ isInView, maskAnim }) => maskAnim && (isInView ? "inset(0%)" : "inset(10%)")};
  transition: clip-path var(--transition);
  will-change: clip-path;
`

export const Button = styled.button`
  ${buttonIcon}
  ${translucentDark}
  z-index: 1;
  margin-inline-end: 20px;
  margin-block-end: 20px;
  align-self: end;
  justify-self: end;
  grid-row: vid / span 1;
  ${columnWidth}
`

export const Content = styled(motion.div)`
  ${columnWidth}
  grid-row: content;

  .order-text-video & {
    margin-block-end: 40px;

    ${getMediaQuery("m")} {
      margin-block-end: 60px;
    }

    ${getMediaQuery("l")} {
      margin-block-end: 80px;
    }
  }

  .order-text-video.width-media-s & {
    ${getMediaQuery("l")} {
      margin-block-end: 40px;
    }
  }

  .order-video-text & {
    margin-block-start: 40px;

    ${getMediaQuery("m")} {
      margin-block-start: 60px;
    }

    ${getMediaQuery("l")} {
      margin-block-start: 80px;
    }
  }

  .order-video-text.width-media-s & {
    ${getMediaQuery("l")} {
      margin-block-start: 40px;
    }
  }

  ${modularTexts}
  hgroup,
  p,
  h2,
  h3 {
    html.prefers-contrast & {
      color: black !important;
      position: relative;

      ::after {
        background: white;
        content: "";
        height: calc(100% + 30px);
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% + 20px);
        z-index: -1;
      }
    }
  }
`
